/* eslint-disable no-shadow */
export enum DomainRegistrarsQueryKeys {
  GetAll = 'domainRegistrars/getAll',
  GetOneById = 'domainRegistrars/getById',
  Create = 'domainRegistrars/create',
  Edit = 'domainRegistrars/edit',
  Delete = 'domainRegistrars/delete',
  Autocomplete = 'domainRegistrars/autocomplete',
  Breadcrumb = 'domainRegistrars/breadcrumb',
}

export enum DomainRegistrarAccountsQueryKeys {
  GetAll = 'domainRegistrarAccounts/getAll',
  ShowPassword = 'domainRegistrarAccounts/showPassword',
  Create = 'domainRegistrarAccounts/create',
  Edit = 'domainRegistrarAccounts/edit',
  Delete = 'domainRegistrarAccounts/delete',
  Autocomplete = 'domainRegistrarAccounts/autocomplete',
}
